<app-table-form *ngIf="customerId" [resourceType]="resourceType"
                [resourceId]="customerId" [preselectFirst]="true"
                [preselectedId]="contactPersonId"
                (rowSelected)="onItemSelected($event)">
</app-table-form>
